
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

 
const ViewClusterRoute = (props) => {
    
    const truckData = (e) => {
        e.stopPropagation();
        props.context.componentParent.onClickShowClusterRouteOnMap(props);
    };
  
    return (
        <div>
            <button className="label label-warning" onClick={truckData} style={{color:"#000",border:"0px"}}>
                <i className="fa fa-eye"></i>Cluster
            </button>
            
        </div>
    );
};

export default ViewClusterRoute;
